// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"652":"f2a46bca","2783":"e0129b94","3326":"ae25743d","3435":"6b970c51","3595":"a48f8242","6727":"71c1d2fe"}[chunkId] + ".chunk.css";
};